import React, { useState } from 'react';
import { currentMembers, formerMembers, otherFormerMembers } from '../data/people';
import { X, Mail, ChevronDown, ChevronUp } from 'lucide-react';
import './People.css';

function People() {
  const [selectedMember, setSelectedMember] = useState(null);
  const [showFormer, setShowFormer] = useState(false);

  return (
    <div className="people-page">
      <div className="container">
        <section className="page-hero">
          <h1>People</h1>
          <p className="subtitle">
            Current and former members of the Astrophysics Group at the
            Center for Theoretical Physics, Polish Academy of Sciences.
          </p>
        </section>

        {/* Current members */}
        <section className="section">
          <h2 className="section-title">Current Members</h2>
          <div className="people-grid">
            {currentMembers.map((member, i) => (
              <div
                className="person-card"
                key={i}
                onClick={() => setSelectedMember(member)}
                role="button"
                tabIndex={0}
                onKeyDown={e => e.key === 'Enter' && setSelectedMember(member)}
              >
                <div className="person-photo">
                  <img src={member.image} alt={member.name} loading="lazy" />
                </div>
                <div className="person-info">
                  <h3>{member.name}</h3>
                  <p className="person-role">{member.role}</p>
                  <p className="person-snippet">{member.snippet}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Former members */}
        <section className="section">
          <button
            className="former-toggle"
            onClick={() => setShowFormer(!showFormer)}
          >
            <h2>Former Members</h2>
            {showFormer ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </button>

          {showFormer && (
            <div className="former-section">
              <div className="former-grid">
                {formerMembers.map((member, i) => (
                  <div className="former-card" key={i}>
                    <div className="former-photo">
                      <img src={member.image} alt={member.name} loading="lazy" />
                    </div>
                    <div>
                      <h4>{member.name}</h4>
                      <p className="former-role">{member.role}</p>
                      {member.current && (
                        <p className="former-current">Now: {member.current}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {otherFormerMembers.length > 0 && (
                <div className="other-former">
                  <h4>Other Former Members & Visitors</h4>
                  <ul>
                    {otherFormerMembers.map((name, i) => (
                      <li key={i}>{name}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
        </section>
      </div>

      {/* Bio modal */}
      {selectedMember && (
        <div
          className="modal-overlay"
          onClick={() => setSelectedMember(null)}
        >
          <div
            className="modal-content"
            onClick={e => e.stopPropagation()}
          >
            <button
              className="modal-close"
              onClick={() => setSelectedMember(null)}
              aria-label="Close"
            >
              <X size={20} />
            </button>
            <div className="modal-header">
              <img src={selectedMember.image} alt={selectedMember.name} />
              <div>
                <h3>{selectedMember.name}</h3>
                <p className="person-role">{selectedMember.role}</p>
                {selectedMember.email && (
                  <a href={`mailto:${selectedMember.email}`} className="modal-email">
                    <Mail size={14} /> {selectedMember.email}
                  </a>
                )}
              </div>
            </div>
            <div className="modal-bio">
              {(Array.isArray(selectedMember.bio) ? selectedMember.bio : [selectedMember.bio || '']).map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default People;
